import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { JdcManagerService } from '../jdc-manager.service';
import { GtwSnackbarService } from '../../../../shared/_services/gtw-snackbar.service';

@Component({
    selector: 'gtw-jdc-tasks-reorder-modal',
    templateUrl: './jdc-tasks-reorder-modal.component.html',
    styleUrls: ['./jdc-tasks-reorder-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class JdcTasksReorderModalComponent implements OnInit, OnDestroy {
  @Input() treeNodes: any[] = [];
  @Input() jcdKey: any;
  @Input() clientKey: any;

  @Output() applied = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  reorderMode = true;
  reorderTasksList: any[] = [];
  reorderOriginalTaskList: any[] = [];
  reorderSubTasksList: any[] = [];
  reorderTaskModel: any = null;
  reorderTaskLoader = false;

  private destroy$ = new Subject<void>();

  constructor(
    private jdcManagerService: JdcManagerService,
    private gtwSnackbarService: GtwSnackbarService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.reorderMode = true;
    this.reorderTasksList = JSON.parse(JSON.stringify(this.treeNodes || []));
    this.reorderOriginalTaskList = JSON.parse(JSON.stringify(this.reorderTasksList));
    this.reorderTaskModel = this.reorderTasksList[0];
    this.reorderSubTasksList = this.reorderTaskModel?.sub_task || [];
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close(): void {
    this.closed.emit();
  }

  setReorderMode(value: boolean): void {
    this.reorderMode = value;
    this.reorderTaskModel = this.reorderTasksList[0] || null;
    this.reorderSubTasksList = this.reorderTaskModel?.sub_task || [];
  }

  reorderSelectTask(task: any): void {
    this.reorderTaskModel = task;
    this.reorderSubTasksList = task?.sub_task || [];
  }

  dropReorderTasks(event: CdkDragDrop<any[]>): void {
    if (!this.reorderMode || event.previousIndex === event.currentIndex) return;
    moveItemInArray(this.reorderTasksList, event.previousIndex, event.currentIndex);
  }

  dropReorderSubTasks(event: CdkDragDrop<any[]>): void {
    if (this.reorderMode || !this.reorderTaskModel?.sub_task || event.previousIndex === event.currentIndex) return;
    moveItemInArray(this.reorderTaskModel.sub_task, event.previousIndex, event.currentIndex);
    this.reorderSubTasksList = this.reorderTaskModel.sub_task;
  }

  clearReorder(): void {
    this.reorderTasksList = JSON.parse(JSON.stringify(this.reorderOriginalTaskList || []));
    this.reorderTaskModel = this.reorderTasksList[0] || null;
    this.reorderSubTasksList = this.reorderTaskModel?.sub_task || [];
  }

  applyReorder(): void {
    const payload = this.jdcManagerService.buildTaskTreePayload(
      this.reorderTasksList,
      this.jcdKey,
      this.clientKey
    );
    if (!payload.length) return;
    this.reorderTaskLoader = true;
    this.jdcManagerService.saveJsonAction('4dk04a', payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.reorderTaskLoader = false;
          if (res?.callSuccess === '1') {
            this.gtwSnackbarService.openSnackBar('Tasks reordered successfully.', 'gtw-snackbar--green');
            this.applied.emit();
          } else {
            this.gtwSnackbarService.openSnackBar('Problem reordering tasks.', 'gtw-snackbar--red');
          }
          this.cdr.detectChanges();
        },
        error: () => {
          this.reorderTaskLoader = false;
          this.gtwSnackbarService.openSnackBar('Problem reordering tasks.', 'gtw-snackbar--red');
          this.cdr.detectChanges();
        }
      });
  }
}
